module.exports = __webpack_public_path__ + "static/img/record.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/record.png
// module id = T4uy
// module chunks = 0